import { render, staticRenderFns } from "./ClasesLista.vue?vue&type=template&id=1c577364&"
import script from "./ClasesLista.vue?vue&type=script&lang=js&"
export * from "./ClasesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports